import { render, staticRenderFns } from "./slide-item.vue?vue&type=template&id=422922b0&"
import script from "./slide-item.vue?vue&type=script&lang=js&"
export * from "./slide-item.vue?vue&type=script&lang=js&"
import style0 from "./slide-item.vue?vue&type=style&index=0&lang=stylus&rel=stylesheet%2Fstylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.4.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "slide-item.vue"
export default component.exports